import './index.css'

const ImageItem = props => {
  const {fcn, data} = props
  const {imageUrl, thumbnailUrl} = data
  const thumbnailFn = () => {
    fcn(imageUrl)
  }
  return (
    <li>
      <button onClick={thumbnailFn} type="button">
        <img alt="thumbnail" className="thumbnail-img" src={thumbnailUrl} />
      </button>
    </li>
  )
}
export default ImageItem
